/* =====================================================================
   FRACAZ · Ficha de producto: enlace del descuento de bienvenida y
   fecha estimada de entrega (envío en 48-72 h laborables).
   Textos en español, inglés y alemán (según el idioma de la tienda).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__fzPdp) return;
  window.__fzPdp = true;

  /* «descuento de bienvenida» → baja hasta la newsletter del pie */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-welcome-link]') : null;
    if (!a) return;
    var box = document.querySelector('.footer-block__newsletter') || document.getElementById('ContactFooter');
    if (!box) return;
    e.preventDefault();
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var input = box.querySelector('input[type=email]');
    if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) {} }, 800);
  });

  /* ---------- Días laborables: sin sábados, domingos ni festivos nacionales ---------- */
  function key(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var list = {};
    [[1, 1], [1, 6], [5, 1], [8, 15], [10, 12], [11, 1], [12, 6], [12, 8], [12, 25]].forEach(function (md) {
      list[y + '-' + md[0] + '-' + md[1]] = true;
    });
    var goodFriday = easterSunday(y);
    goodFriday.setDate(goodFriday.getDate() - 2);
    list[key(goodFriday)] = true;
    holidayCache[y] = list;
    return list;
  }

  function isBusinessDay(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    return !holidays(d.getFullYear())[key(d)];
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isBusinessDay(d)) n--;
    }
    return d;
  }

  /* ---------- «Si lo pides ahora, te llega entre…» ---------- */
  var ES_DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var ES_MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var EN_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var EN_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DE_DAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var DE_MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function renderEta(el) {
    var now = new Date();
    var from = addBusinessDays(now, 2);
    var to = addBusinessDays(now, 3);
    var sameMonth = from.getMonth() === to.getMonth();
    var lang = el.getAttribute('data-lang') || 'es';
    var html;
    if (lang === 'en') {
      var f = EN_DAYS[from.getDay()] + ' ' + from.getDate() + (sameMonth ? '' : ' ' + EN_MONTHS[from.getMonth()]);
      var t = EN_DAYS[to.getDay()] + ' ' + to.getDate() + ' ' + EN_MONTHS[to.getMonth()];
      html = 'Order now and get it between <strong>' + f + '</strong> and <strong>' + t + '</strong>.';
    } else if (lang === 'de') {
      var fd = DE_DAYS[from.getDay()] + ', ' + from.getDate() + '.' + (sameMonth ? '' : ' ' + DE_MONTHS[from.getMonth()]);
      var td = DE_DAYS[to.getDay()] + ', ' + to.getDate() + '. ' + DE_MONTHS[to.getMonth()];
      html = 'Jetzt bestellen und zwischen <strong>' + fd + '</strong> und <strong>' + td + '</strong> erhalten.';
    } else {
      var fe = ES_DAYS[from.getDay()] + ' ' + from.getDate() + (sameMonth ? '' : ' de ' + ES_MONTHS[from.getMonth()]);
      var te = ES_DAYS[to.getDay()] + ' ' + to.getDate() + ' de ' + ES_MONTHS[to.getMonth()];
      html = 'Si lo pides ahora, te llega entre el <strong>' + fe + '</strong> y el <strong>' + te + '</strong>.';
    }
    el.innerHTML = html;
    el.hidden = false;
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fz-eta]'), renderEta);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
